import {Staff} from './staff.model';
import {Walkin} from './walkin.model';

export namespace Lead {
  export interface Model {
    pk: number;
    id: number;
    __str__: string;
    lead_creation: Date;
    record_source: Source;
    record_source_display: string;
    creator: number;
    referrer: number;
    // TODO
    // creator: Staff.FieldValue;
    // referrer: Staff.FieldValue;
    first_name: string;
    middle_name: string;
    last_name: string;
    salutations: string;
    cellphone_number: string;
    landline_number: string;
    email_address: string;
    birthday: Date;
    reply_state: MessageState;
    reply_state_display: string;
    message_last_read: number;  // TODO
    agency: number; // TODO
    users: Staff.FieldValue[];
    latest_application: number;
    // TODO latest_application: LoanApplication.FieldValue;
    latest_walkin: Walkin.Model;
    // subscriptions:;  // TODO
    loan_ranger_id: number;
    mifos_client_id: number;
    vars: { [key: string]: any };
  }

  export interface FieldValue {
    pk: number;
    __str__: string;
  }

  export enum Source {
    leadForm = 'lead_form',
    contactUs = 'contact_us',
    walkIn = 'walk_in',
    agencyReferral = 'agency_referral',
    inboundMessage = 'inbound_message',
    outboundMessage = 'outbound_message',
    staffCreated = 'staff_created',
    fromConsole = 'console',
    bot = 'bot',
    seafarerCenter = 'seafarer_center',
  }

  export enum MessageState {
    noInbound = 'no_inbound',
    unread = 'unread',
    cleared = 'cleared',
    blocked = 'blocked',
  }
}
